<template>
  <v-dialog width="150" v-model="visible" overlay-opacity="0" persistent>
    <v-card width="150" height="150" style="background-color: rgba( 255, 255, 255, 0.5 );">
      <v-overlay value="true" :absolute="true" opacity="0.66" class="text-center">
        <v-progress-circular indeterminate size="44"></v-progress-circular>
        <p class="mt-5 mb-0">로딩중입니다.</p>
      </v-overlay>
    </v-card>
  </v-dialog>
</template>

<script>
import store from '@/store'

export default {
  name: 'LoadingDialog',
  computed: {
    visible() {
      return store.state.popup.loadingDialog
    }
  }
}
</script>

<style scoped>

</style>
